import ky, { isHTTPError, type Options } from "ky";
import { z } from "zod";

import {
  ApiError,
  RequestValidationApiError,
  UnauthorizedApiError,
} from "./errors";

export type RequestOptions = Pick<Options, "signal" | "timeout">;

const backendErrorSchema = z.object({
  message: z.string().trim().min(1),
});

export const publicClient = ky.create({
  prefix: import.meta.env.PUBLIC_API_BASE_URL,
  retry: 0,
  timeout: 30_000,
  hooks: {
    beforeError: [
      ({ error }) => {
        if (!isHTTPError(error)) {
          return error;
        }

        const backendError = backendErrorSchema.safeParse(error.data);
        const userMessage = backendError.success
          ? backendError.data.message
          : undefined;

        if (error.response.status === 401) {
          return new UnauthorizedApiError({
            cause: error,
            requestAuthentication:
              error.options.context.authentication === "session"
                ? "session"
                : "public",
            userMessage,
          });
        }

        if (error.response.status === 422) {
          return new RequestValidationApiError({
            cause: error,
            userMessage,
          });
        }

        return new ApiError({
          cause: error,
          status: error.response.status,
          userMessage,
        });
      },
    ],
  },
});
